import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  loginDisplay = false;

  constructor(
    private authService: MsalService,
    private commonSvc: CommonService,
    private router: Router,
  ) { }

  ngOnInit() {

  // this.router.navigateByUrl('allfiles');

    this.commonSvc.isLogin.subscribe((status: boolean) => {
      this.loginDisplay = status
      if (status) {
        setTimeout(()=>{
          this.router.navigateByUrl('AudioTranslation');
        })
      }
      // else{
      //   this.login();
      // }
    })

  }

  login() {
    // this.initializeMsal();
    this.authService.loginRedirect();
  }
  // async initializeMsal() {
  //   await this.authService.initialize();
  // }

  ngOnDestroy(): void {}
}
